import React, { Component } from "react";
import ReactDOM from "react-dom";
import PlusSidebar from './PlusSlidebar';
// import ReactTooltip from 'react-tooltip';
import { OverlayTrigger, Popover, DropdownButton } from 'react-bootstrap';
import map  from 'lodash/map';
import size  from 'lodash/size';
import groupBy  from 'lodash/groupBy';
import round  from 'lodash/round';
import findIndex  from 'lodash/findIndex';
import find  from 'lodash/find';
import filter  from 'lodash/filter';
import Button from "../common/Button";
import QuotesCard from "./QuotesCard";
import Gmaps from "./Gmaps";
import GmapsEmergency from "../Emergency/GmapsEmergency";
import JobDetails from "./JobDetails";
import InputRange from "react-input-range";
import ToggleSwitch from "@trendmicro/react-toggle-switch";
import AcceptedQuotes from "./AcceptedQuotes";
import CarType from "../common/CarType";
import Rating from "react-rating";
import CustomScroll from "react-custom-scroll";
import PageLoader from "../common/PageLoader";
import ChatBox from "./ChatBox";
import TimePicker from "rc-time-picker";
import moment from "moment";
import { dateToTime } from "../../helpers";
import RequestMobileSort from "../common/RequestMobileSort";
import RequestMobileFilter from "./RequestMobileFilter";
import {appBasePath, imageBasePath,phoneNumber, phoneNumberJop} from "../../constants/staticData";

export default class RequestCard extends Component {
  constructor(...args) {
    super(...args);
    this.toggleSwitchVal = {
      Open24_7: false,
      showFavourites: false,
      byCash: false,
      byCreditcard: false
    };

    console.log("Hello sir = ",this.props)


    const currentRoute = this.props.router.getCurrentLocation();
    const jobid =
      currentRoute.query && currentRoute.query.jobid
        ? currentRoute.query.jobid
        : undefined;
    const garage_id =
      currentRoute.query && currentRoute.query.garage_id
        ? currentRoute.query.garage_id
        : undefined;
    this.state = {
      windowWidth: 0,
      viewInfo:true,
      showFullPageLoader: false,
      mobJD:  "job-card",
      isResponsiveViewClose: false,
      mobileFilterItem: false,
      mobileSortItem: false,
      locationSearch: {
        lat: undefined,
        lng: undefined,
        pinImage: "",
        
      },
      isButtonLoading: false,
      isLoading: true,
      filterdropdownVisible: false,
      dataChange: "",
      setCenter: false,
      mapsCenter: { lat: 12.9952672, lng: 77.5905857 },
      switched: false,
      filterSort: "dateNO",
      filterdropdown: false,
      driverInfo: false,
      pollCountObj: "",
      batchId: "",
      now: moment(),
      sortBydropdown: false,
      daySelected: {
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thrusday: false,
        friday: false,
        saturday: false
      },
      daySelectedKey: [false, false, false, false, false, false, false],
      daySelectedValue: [],
      changedWeek: false,
      filterType: "",
      open: false,
      rangeFromDefault: moment("2016-12-19T00:00:00+05:30"),
      rangeToDefault: moment("2016-12-19T23:59:00+05:30"),
      rangefrom: undefined,
      rangeto: undefined,
      jobUpdates: jobid ? "quotes" : "details",
      currentWidth: "",
      activelatitude: "",
      activelongitue: "",
      jobCardDetails: [],
      quotation: jobid ? false : true,
      messages: jobid ? true : false,
      mapView: jobid ? false : true,
      quotationView: jobid ? true : false,
      activeSvg:
        "data:image/svg+xml,%3Csvg%20width%3D%2236px%22%20height%3D%2240px%22%20viewBox%3D%220%200%2036%2040%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%3E%0A%20%20%20%20%3C%21--%20Generator%3A%20Sketch%2042%20%2836781%29%20-%20http%3A//www.bohemiancoding.com/sketch%20--%3E%0A%20%20%20%20%3Ctitle%3Elocation-pin%20copy%209%3C/title%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C/desc%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%2C3.99742905%20C0%2C1.78970995%201.7852456%2C0%203.99017859%2C0%20L32.0098214%2C0%20C34.2135362%2C0%2036%2C1.78197514%2036%2C3.99742905%20L36%2C25.1917601%20C36%2C27.3994792%2034.4851438%2C30.1580906%2032.6302879%2C31.3444558%20L19.0975342%2C40%20L3.48057588%2C31.1594879%20C1.5583069%2C30.071322%200%2C27.407214%200%2C25.1917601%20L0%2C3.99742905%20Z%22%20id%3D%22path-1%22%3E%3C/path%3E%0A%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20maskContentUnits%3D%22userSpaceOnUse%22%20maskUnits%3D%22objectBoundingBox%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2236%22%20height%3D%2240%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C/use%3E%0A%20%20%20%20%20%20%20%20%3C/mask%3E%0A%20%20%20%20%3C/defs%3E%0A%20%20%20%20%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-opacity%3D%220.455219656%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22location-pin-copy-9%22%20stroke%3D%22%23FFFFFF%22%20stroke-width%3D%224%22%20fill%3D%22%2323AE49%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22Rectangle-10-Copy-3%22%20mask%3D%22url%28%23mask-2%29%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C/use%3E%0A%20%20%20%20%20%20%20%20%3C/g%3E%0A%20%20%20%20%3C/g%3E%0A%3Ctext%20transform%3D%22translate%2818.5%2021%29%22%20fill%3D%22%23fff%22%20style%3D%22font-family%3A%20Arial%2C%20sans-serif%3Bfont-weight%3Abold%3Btext-align%3Acenter%3B%22%20font-size%3D%2212%22%20text-anchor%3D%22middle%22%3E",
      svg:
        "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2236px%22%20height%3D%2240px%22%20viewBox%3D%220%200%2036%2040%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2042%20(36781)%20-%20http%3A%2F%2Fwww.bohemiancoding.com%2Fsketch%20--%3E%0A%20%20%20%20%3Ctitle%3ERectangle%2010%20Copy%203%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%2C3.99742905%20C0%2C1.78970995%201.7852456%2C0%203.99017859%2C0%20L32.0098214%2C0%20C34.2135362%2C0%2036%2C1.78197514%2036%2C3.99742905%20L36%2C25.1917601%20C36%2C27.3994792%2034.4851438%2C30.1580906%2032.6302879%2C31.3444558%20L19.0975342%2C40%20L3.48057588%2C31.1594879%20C1.5583069%2C30.071322%200%2C27.407214%200%2C25.1917601%20L0%2C3.99742905%20Z%22%20id%3D%22path-1%22%3E%3C%2Fpath%3E%0A%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20maskContentUnits%3D%22userSpaceOnUse%22%20maskUnits%3D%22objectBoundingBox%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2236%22%20height%3D%2240%22%20fill%3D%22white%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%3C%2Fmask%3E%0A%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%3Cg%20id%3D%22Symbols%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke-opacity%3D%220.455219656%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%22location-pin%22%20stroke%3D%22%23FFFFFF%22%20stroke-width%3D%224%22%20fill%3D%22%23EE3124%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20id%3D%22Rectangle-10-Copy-3%22%20mask%3D%22url(%23mask-2)%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3Ctext%20transform%3D%22translate(18.5%2021)%22%20fill%3D%22%23fff%22%20style%3D%22font-family%3A%20Arial%2C%20sans-serif%3Bfont-weight%3Abold%3Btext-align%3Acenter%3B%22%20font-size%3D%2212%22%20text-anchor%3D%22middle%22%3E",
      svgEnd: "</text>%0A</svg>",
      distValue: { min: 0, max: 20 },
      priceValue: { min: 0, max: 30000 },
      selectedVendorId: garage_id || 0,
      ratingValue: 0,
      inValidTime: false,
      selectedJobId: jobid || undefined,
      sortValue: "distance",
      filterActivated: undefined,
      driverLatInfo: "",
      driverLngInfo: "",
      openPopover: false,
      isCardPayment: true,
      isShopPayment: false,
      isPaymentButtonLoading: false,
      isPayAtShopEnabled: false,
    };
    this.removeFav = this.removeFav.bind(this);
    this.acceptQuotes = this.acceptQuotes.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
    this.windowWidth = this.windowWidth.bind(this);
    this.sortBy = this.sortBy.bind(this);
    this.viewMessaging = this.viewMessaging.bind(this);
    this.filterSelect = this.filterSelect.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.driverDetails = this.driverDetails.bind(this);
    this.updateDatalat = this.updateDatalat.bind(this);
    this.makePayment = this.makePayment.bind(this);
    this.InspectionTotal = this.InspectionTotal.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

  }

  componentWillMount() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.showPosition.bind(this));
    } else {
      alert("Geolocation is not supported by this browser.");
    }
    this.updateDimensions();
    window.addEventListener("mousedown", this.bodyClick.bind(this));


    window.addEventListener('resize', this.updateWindowDimensions);
    // if (this.props.jobType == 'waiting' || this.props.jobType == undefined) {
    //   this.setState({ jobUpdates: "details" })
    // }
  }
  updateWindowDimensions() {
    this.setState({ mobJD: ! this.state.isResponsiveViewClose && window.innerWidth < 812 ? "": "job-card"});
  }
  componentDidMount() {
    // console.log("bookingRequestReducer = ", this.props);
    window.addEventListener("resize", this.updateDimensions);
    // if (this.props.jobType == 'waiting' || this.props.jobType == undefined) {
    //   this.setState({ jobUpdates: "details" })
    // }
    const currentRouteLocation = this.props.router.getCurrentLocation();
    if (
      currentRouteLocation.query &&
      currentRouteLocation.query.view == "message"
    ) {
      const jobid =
        currentRouteLocation.query && currentRouteLocation.query.jobid
          ? currentRouteLocation.query.jobid
          : undefined;
      this.viewMessaging(jobid);
      this.setState({ messages: true });
    } else if (
      currentRouteLocation.query &&
      currentRouteLocation.query.view == "quotes"
    ) {
      this.showLoader();
      setTimeout(() => {
        this.jobDetail("quotes");
        this.viewQuotation();
        this.setState({ quotationView: false, mobJD: 'job-card' });
        this.showLoader();
      }, 2000);
    }
    // if (this.props.jobType == 'active') {
    //   this.setState({ mapView: true, quotationView: false })
    // }
    let that = this;
    window.socket.on('Driver Location', function (data) {
      that.updateDatalat(data);
    });
  }

  updateDatalat(data) {
    this.setState({
      driverLatInfo: data.location.lat,
      driverLngInfo: data.location.lng
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.bookingRequestReducer.hideButtonLoader) {
      this.setState({ isButtonLoading: false });
    }
    if (nextProps.bookingRequestReducer.isLoaded) {
      this.setState({ isLoading: false });
      this.props.actions.clearBookingReducerComponentKey();
    }
    let batchId =
      nextProps &&
      nextProps.bookingRequestReducer &&
      nextProps.bookingRequestReducer.bookingRequests &&
      nextProps.bookingRequestReducer.bookingRequests[nextProps.requestId] &&
      nextProps.bookingRequestReducer.bookingRequests[nextProps.requestId]
        .batch_id;
    let pollCountObj =
      nextProps &&
      nextProps.bookingRequestReducer &&
      nextProps.bookingRequestReducer.batchIdList &&
      nextProps.bookingRequestReducer.batchIdList[batchId];
    if (
      nextProps &&
      nextProps.bookingRequestReducer &&
      nextProps.bookingRequestReducer.bookingRequests &&
      nextProps.requestId &&
      nextProps.bookingRequestReducer.batchIdList
    ) {
      this.setState({
        pollCountObj: pollCountObj,
        batchId: batchId
      });
    }
    let jobData =
      nextProps.bookingRequestReducer.bookingRequests &&
      nextProps.bookingRequestReducer.bookingRequests[nextProps.requestId] &&
      nextProps.bookingRequestReducer.bookingRequests[nextProps.requestId];

    let displayname =
      jobData && jobData.requeststatus && jobData.requeststatus.displayname;
    if (displayname == "Completed") {

      this.updateWindowDimensions();
      this.setState({ jobUpdates: 'quotes' })
    }

    let vendorQuotesList =
      jobData && jobData.vendorQuotesList ? jobData.vendorQuotesList : {};
    let jobCardDetails = [];
    map(vendorQuotesList.garagejobquotes, value => {
      jobCardDetails.push(value);
    });
    jobCardDetails &&
      map(jobCardDetails, (value, key) => {
        // console.log('What is the value ', value);
        if (value.garageId === this.state.selectedVendorId) {
          jobCardDetails[key] = {
            ...jobCardDetails[key],
            isActive: true
          };
          return;
        }
        /*if (key == 0) {
          jobCardDetails[key] = {
            ...jobCardDetails[key],
            isActive: true
          };
        } else {
          jobCardDetails[key] = {
            ...jobCardDetails[key],
            isActive: false
          };
        }*/
      });
    jobCardDetails &&
      this.setState({
        jobCardDetails: jobCardDetails,
        setCenter: true,
        mapsCenter:
          jobCardDetails.length && jobCardDetails[0].garage
            ? {
              lat: Number(jobCardDetails[0].garage.latitude),
              lng: Number(jobCardDetails[0].garage.longitude)
            }
            : { lat: 0, lng: 0 }
      });

    if(jobData && jobData.paymentstatus && jobData.paymentstatus.method && ! this.state.isPaymentButtonLoading){
      this.setState({ isPayAtShopEnabled:  jobData.paymentstatus.method == 'Pay at Shop'?true: false })
    }


    if (!this.state.driverLatInfo && jobData) {
      if (
        jobData &&
        jobData.garagejobquotes &&
        jobData.garagejobquotes.length > 0 &&
        jobData.garagejobquotes[0].emergencyjobdetails[0] != undefined &&
        jobData.garagejobquotes[0].emergencyjobdetails.length > 0
      ) {
        let driverlatlong = jobData.garagejobquotes[0].emergencyjobdetails[0];
        this.setState({
          driverLatInfo: driverlatlong.latitude,
          driverLngInfo: driverlatlong.longitude
        });
      }
    }

    if(nextProps && nextProps.bookingRequestReducer &&  nextProps.bookingRequestReducer.status){

      console.log("12334 -- 1")
     if(nextProps.bookingRequestReducer.paymentUrl && this.state.isPaymentButtonLoading ) {
       console.log("12334 -- 2")
       if (nextProps.bookingRequestReducer.method == 1) {
         console.log("12334 -- 3")
         window.location.href = nextProps.bookingRequestReducer.paymentUrl;
       } else {
         this.props.actions.getBookingRequest(nextProps.requestId, this.props.router);

         this.setState({isPaymentButtonLoading: false})
       }
     }

    }else{
      this.setState({isPaymentButtonLoading: false})
    }


  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
    window.removeEventListener("mousedown", this.bodyClick.bind(this));
  }

  showLoader() {
    this.setState({
      showFullPageLoader: !this.state.showFullPageLoader,
    });
  }

  jobDetail(val) {
    this.setState({ jobUpdates: val });
  }

  showPosition(position) {
    let positionVal = {
      lat: position.coords.latitude,
      lng: position.coords.longitude,
      pinImage: `${imageBasePath}/images/map_blue_pointer.png`
    };
    this.setState({ locationSearch: positionVal });
  }
  hideandshow()
  {
    this.setState({
      viewInfo:!this.state.viewInfo
    })
  }

  bodyClick(e) {
    if (
      (e.target.closest(".filter-dropdown") ||
        e.target.closest(".showFilters")) &&
      !this.state.filterdropdown
    ) {
      this.setState({ filterdropdown: true, sortBydropdown: false });
    } else if (
      (e.target.closest(".showSortBy") || e.target.closest(".sortFilter")) &&
      !this.state.sortBydropdown
    ) {
      this.setState({ sortBydropdown: true, filterdropdown: false });
    } else if (e.target.closest(".mobile-tp")) {
      this.setState({ filterdropdown: false });
    } else if (e.target.closest(".rc-time-picker-panel")) {
      this.setState({ filterdropdown: true, sortBydropdown: false });
    } else if (
      e.target.closest(".Filterby") == null &&
      e.target.closest(".sortFilter") == null
    ) {
      this.setState({ filterdropdown: false, sortBydropdown: false });
    }
  }

  filterDropDownFunc(e) {
    if (!this.state.filterdropdownVisible) {
      this.setState({ filterdropdown: e });
    }
  }

  updateDimensions() {
    const windowWidth = this.windowWidth();
    this.setState({ currentWidth: windowWidth });
  }

  windowWidth() {
    let docElemProp = window.document.documentElement.clientWidth,
      body = window.document.body;
    return (
      (window.document.compatMode === "CSS1Compat" && docElemProp) ||
      (body && body.clientWidth) ||
      docElemProp
    );
  }
  btnClickFunc(requestId, jobId) {
    this.props.actions.getQuotesPricingDetails(requestId, jobId);
    this.setState({
      mapView: false,
      selectedJobId: jobId,
      quotationView: true,
      quotation: true,
      messages: false
    });
    if (this.state.currentWidth < 991) {
      this.viewQuotation();
    }
  }
  viewMessaging(jobId) {
    this.setState({
      mapView: false,
      selectedJobId: jobId,
      quotationView: true,
      quotation: false,
      messages: true,
      jobUpdates: "quotes",
      mobJD: ''
    });
  }
  mapClick(map) {
    let update,
      newDetails = [];
    this.state.jobCardDetails.map((value, key) => {
      if (
        value.garage &&
        (round(Number(value.garage.latitude), 6) ==
          round(map.latLng.lat(), 6) &&
          round(Number(value.garage.longitude), 6) ==
          round(map.latLng.lng(), 6))
      ) {
        update = {
          ...value,
          pinImage: this.state.activeSvg + key + this.state.svgEnd,
          isActive: true,
          zIndex: 999
        };
      } else {
        update = {
          ...value,
          pinImage: this.state.svg + key + this.state.svgEnd,
          isActive: false,
          zIndex: 9
        };
      }
      newDetails.push(update);
    });
    this.setState({
      jobCardDetails: newDetails
    });
    this.setState({
      scrollTo:
        Object.keys(this.currentTopEle).length > 0
          ? ReactDOM.findDOMNode(this.currentTopEle).getBoundingClientRect().top
          : 0
    });
  }
  ClickedQuoteCard(key, vendorId) {
    let update,
      newArray = [],
      centerLat = undefined,
      centerLng = undefined;
    map(this.state.jobCardDetails, (val, index) => {
      if (val.garage && val.garage.id == vendorId) {
        update = {
          ...val,
          isActive: true,
          pinImage: this.state.activeSvg + index + this.state.svgEnd,
          zIndex: 999
        };
        (centerLat = val.garage.latitude), (centerLng = val.garage.longitude);
      } else {
        update = {
          ...val,
          isActive: false,
          pinImage: this.state.svg + index + this.state.svgEnd,
          zIndex: 9
        };
      }
      newArray.push(update);
    });
    this.setState({
      jobCardDetails: newArray,
      selectedVendorId: vendorId,
      mapsCenter: { lat: centerLat, lng: centerLng },
      setCenter: true
    });
  }
  closeChat() {
    this.setState({ mapView: true, quotationView: false });
  }
  viewQuotation() {
    this.setState({
      quotation: true,
      messages: false,
      driverInfo: false,
      mobJD: ""
    });
  }
  viewMessages() {
    this.setState({ quotation: false, messages: true, mobJD: "" });
  }
  driverDetails() {
    this.setState({ quotation: false, driverInfo: true });
  }

  day(selDay, day) {
    let days = { ...this.state.daySelected };
    let daysValue = [...this.state.daySelectedKey];
    days[selDay] = !this.state.daySelected[selDay];
    daysValue[day] = !this.state.daySelectedKey[day];
    this.setState({
      daySelected: days,
      daySelectedKey: daysValue
    });
  }

  sortBy(jobId, value) {
    this.props.actions.getVendorQuotesList(
      jobId,
      value,
      this.state.distValue,
      this.state.priceValue,
      this.state.daySelectedValue,
      this.state.rangefrom,
      this.state.rangeto,
      this.state.ratingValue,
      this.toggleSwitchVal,
      this.props.commonReducer.userLocation,
    );
  }

  filterOption(val, sortValue) {
    this.setState({
      filterSort: val,
      sortBydropdown: false,
      sortValue: sortValue
    });
  }

  clearFilter(jobId) {
    this.toggleSwitchVal = {
      Open24_7: false,
      showFavourites: false,
      byCash: false,
      byCreditcard: false
    };
    this.setState({
      ratingValue: 0,
      inValidTime: false,
      TimePickerFrom: undefined,
      daySelectedValue: [],
      daySelectedKey: [false, false, false, false, false, false, false],
      TimePickerTo: undefined,
      rangefrom: undefined,
      rangeto: undefined,
      filterActivated: false,
      rangeFromDefault: moment("2016-12-19T00:00:00+05:30"),
      rangeToDefault: moment("2016-12-19T23:59:00+05:30"),
      distValue: { min: 0, max: 20 },
      priceValue: { min: 0, max: 30000 },
      daySelected: {
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thrusday: false,
        friday: false,
        saturday: false
      }
    });
    this.props.actions.getVendorQuotesList(jobId, this.state.sortValue);
  }

  switch(val) {
    this.toggleSwitchVal[val] = !this.toggleSwitchVal[val];
    if (val == "byCash") {
      this.toggleSwitchVal.byCreditcard = false;
    } else if (val == "byCreditcard") {
      this.toggleSwitchVal.byCash = false;
    }
    this.setState({ switched: !this.state.switched });
  }

  rangefrom(value, menu) {
    let res = {
      rangefrom: value.format("hh:mm A"),
      rangeFromDefault: value
    };
    if (menu) {
      res["filterdropdown"] = false;
    }
    this.setState(res);
  }

  rangeTo(value, menu) {
    let res = {
      rangeto: value.format("hh:mm A"),
      rangeToDefault: value
    };
    if (menu) {
      res["filterdropdown"] = false;
    }
    this.setState(res);
  }

  filterSelect(jobId) {
    let daysSelected = [];
    let filterActivated = false;
    map(this.state.daySelectedKey, (value, key) => {
      if (value) {
        daysSelected.push(key + 1);
      }
    });
    if (
      (this.toggleSwitchVal && this.toggleSwitchVal["byCash"]) ||
      this.toggleSwitchVal["byCreditcard"] ||
      this.toggleSwitchVal["Open24_7"] ||
      this.toggleSwitchVal["showFavourites"] ||
      this.state.ratingValue ||
      this.state.distValue ||
      this.state.priceValue ||
      daysSelected.length ||
      this.state.rangefrom ||
      this.state.rangeTo
    ) {
      filterActivated = true;
    }
    this.setState({
      filterdropdown: false,
      daySelectedValue: daysSelected,
      filterActivated: filterActivated,
      mobileFilterItem: false
    });
    this.props.actions.getVendorQuotesList(
      jobId,
      this.state.sortValue,
      this.state.distValue,
      this.state.priceValue,
      daysSelected,
      this.state.rangefrom,
      this.state.rangeto,
      this.state.ratingValue,
      this.toggleSwitchVal,
      this.props.commonReducer.userLocation,
    );
  }

  statusIndicatorFunc(status, previousDisplayname) {
    if (status == "Cancelled" || status == "Expired") {
      status = previousDisplayname;
    }
    if (
      status == "Completed" ||
      status == "Accepted" ||
      status == "In-progress" || status == "Driver Accepted"
    ) {
      return "Accepted Quotes";
    } else {
      return "Quotes";
    }
  }

  removeFav(event, status, vendorId, userRequestId) {
    event.stopPropagation();
    event.preventDefault();
    this.props.actions.changeFavouriteSelection(
      vendorId,
      status,
      "activeVendors",
      userRequestId
    );
  }

  ratingOnChange(rating) {
    this.setState({ ratingValue: rating });
  }

  setCenter() {
    this.setState({ setCenter: true });
  }

  acceptQuotes(id, jobID, requestId, router) {
    this.setState({ isButtonLoading: true });
    this.props.actions.acceptQuotes(id, jobID, requestId, router);
  }
  bckButton() {
    this.setState({ mobileSortItem: false, mobileFilterItem: false });
  }
  requestSort(val, sortVal, JobId) {
    this.filterOption(val, sortVal);
    this.sortBy(JobId, sortVal);
    this.setState({ mobileSortItem: false });
  }
  distValue(type, value) {
    type == "distance"
      ? this.setState({ distValue: value })
      : this.setState({ priceValue: value });
  }
  changeJobType() {
    this.setState({ mobJD: "" });
  }

  makePayment( jobId, requestId) {
   

    this.setState({ isPaymentButtonLoading: true })

    let method = 2;

    if(this.state.isCardPayment)
      method = 1;

    this.props.actions.makePayment(requestId, jobId, method);
  }

  updateRadioButton(type) {


    this.setState({ isCardPayment: type == "cardPayment"? true: false, isShopPayment : type == "shopPayment"? true: false })

  }

  InspectionTotal(qouteInfo){
    let totalInspection = 0;
    qouteInfo.map((quote)=>{
      totalInspection+=quote.inspectionamount;
    })
    return Number(totalInspection);
  }

  render() {


    console.log("hi = ",this.props)
    const {
      requestId,
      jobType,
      router,
      bookingRequestReducer,
      actions,
      userPaymentStatus
    } = this.props;
    let jobNotesObj = {};

    console.log("id=",requestId)

    console.log("userPaymentStatus",userPaymentStatus)
    { console.log("bookingRequestReducer = ", bookingRequestReducer); }
    if (bookingRequestReducer && bookingRequestReducer.garagejobquotesdetail && bookingRequestReducer.garagejobquotesdetail.length) {
      jobNotesObj = bookingRequestReducer.garagejobquotesdetail[0].garage.garagejobnotes[0];
    }
    let jobLeftGridValue = "";
    let jobRightGridValue = "";
    if (this.state.currentWidth <= 1155 && this.state.currentWidth >= 992) {
      jobLeftGridValue = "col-md-7";
      jobRightGridValue = "col-md-5";
    } else if (
      this.state.currentWidth <= 1345 &&
      this.state.currentWidth >= 1155
    ) {
      jobLeftGridValue = "col-md-6";
      jobRightGridValue = "col-md-6";
    } else {
      jobLeftGridValue = "col-md-5";
      jobRightGridValue = "col-md-7";
    }

    let jobData =
      bookingRequestReducer.bookingRequests &&
      bookingRequestReducer.bookingRequests[requestId] &&
      bookingRequestReducer.bookingRequests[requestId];
    let jobId = jobData && jobData.id;
    let vendorQuotesList =
      jobData && jobData.vendorQuotesList ? jobData.vendorQuotesList : {};
    let displayname =
      jobData && jobData.requeststatus && jobData.requeststatus.displayname;
    if (displayname == "accepted") {
      this.changeJobType.bind(this);
    }


    let previousDisplayname =
      jobData &&
      jobData.previousrequeststatus &&
      jobData.previousrequeststatus.displayname;
    let vendorIndex =
      this.state.selectedVendorId &&
      findIndex(vendorQuotesList.garagejobquotes, {
        garageId: Number(this.state.selectedVendorId)
      });

    let garageQuotesPricingDetails = {};

    garageQuotesPricingDetails =
      vendorIndex != -1 &&
      vendorQuotesList.garagejobquotes &&
      size(vendorQuotesList.garagejobquotes) &&
      vendorQuotesList.garagejobquotes[vendorIndex];
    garageQuotesPricingDetails = (jobData && displayname == 'Accepted') ||
      displayname == 'In-progress' ||
      displayname == 'Completed' || displayname == 'Driver Accepted' ||
      (displayname == 'Cancelled' && previousDisplayname == 'Accepted') ||
      (displayname == 'Expired' && previousDisplayname == 'Accepted')
      ? jobData.garagejobquotes && jobData.garagejobquotes[0]
      : garageQuotesPricingDetails;
    garageQuotesPricingDetails = (!garageQuotesPricingDetails &&
      (displayname == 'Cancelled' && previousDisplayname == 'Active')) ||
      (displayname == 'Expired' && previousDisplayname == 'Active')
      ? vendorQuotesList.garagejobquotes &&
      size(vendorQuotesList.garagejobquotes) &&
      vendorQuotesList.garagejobquotes[0]
      : garageQuotesPricingDetails;
    let promoOffer = jobData && jobData.offer ? jobData.offer : null;
    let totalAmount = garageQuotesPricingDetails && garageQuotesPricingDetails.finalAmount;
    let vatAmount = garageQuotesPricingDetails && garageQuotesPricingDetails.taxesAmount;
    let vatPercent = garageQuotesPricingDetails && garageQuotesPricingDetails.taxes && garageQuotesPricingDetails.taxes.length && garageQuotesPricingDetails.taxes[0].value;
    let offerDiscount = 0;
    console.log(promoOffer);
    if(garageQuotesPricingDetails && garageQuotesPricingDetails.discountAmount){
         offerDiscount = garageQuotesPricingDetails.discountAmount? garageQuotesPricingDetails.discountAmount: '--';
         totalAmount -= offerDiscount;
    }


    let StartDate = new Date(this.props.displayname == "Expired" || this.props.displayname == "Cancelled" ?  jobData.updatedAt : jobData && jobData.plus==true ? jobData.special_services[0].preferredStarttime: jobData && jobData.userPrefferedDatetime);
    let EndDate = jobData && jobData.plus == true ? jobData && jobData.special_services && jobData.special_services.length && jobData.special_services[0].preferredEndtime ? new Date(jobData.special_services[0].preferredEndtime) : ''
                : jobData && jobData.garagejobquotes && jobData.garagejobquotes.length && jobData.garagejobquotes[0].jobEndDatetime ? new Date(jobData.garagejobquotes[0].jobEndDatetime) : ''

    if ((this.props.displayname == "Active" || this.props.displayname == "In-progress" || this.props.displayname == "Completed") && jobData && jobData.plus == true) {
      this.label = { title: "Created Date", dateTime: "Pickup Date Time", location: "Pickup Location" };
    }
   else if (this.props.displayname == "Active" && jobData.plus != true) {
      this.label = { title: "Created Date", dateTime: "Preferred Date", location: "Preferred Location" };
    }

    else if (this.props.displayname == "Waiting") {
      this.label = { title: "Created Date", dateTime: "Preferred Date", location: "Preferred Location" };
    } else if (this.props.displayname == "Completed") {
      this.label = { title: "Created Date", dateTime: "Completed Date", location: "Location" };
    } else if (this.props.displayname == "Expired" || this.props.displayname == "Cancelled") {
      this.label = { title: `Created Date`, dateTime: `${this.props.displayname} Date`, location: "Location" };
    } else {
      this.label = { title: "Created Date", dateTime: "Pickup Date Time", location: "Pickup Location" };
    }
    let Months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
   // let createdDate = new Date(jobData.createdAt);
    //createdDate = createdDate.getDate() + ' ' + Months[createdDate.getMonth()] + ' ' + createdDate.getFullYear().toString().substring(2) + ' ' + createdDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
    const StartTime = (jobData && jobData.services && jobData.services.name !== "Servicing")?(' ' + StartDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })):' ';
    const EndTime = (jobData && jobData.services && jobData.services.name !== "Servicing")?+ ' ' + EndDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) : '';
    EndDate = EndDate ? EndDate.getDate() + ' ' + Months[EndDate.getMonth()] + ' \'' + EndDate.getFullYear().toString().substring(2)  :'';
    StartDate = StartDate.getDate() + ' ' + Months[StartDate.getMonth()] + ' ' + StartDate.getFullYear().toString().substring(2)+' | ' +StartTime+' - '+EndTime;

    let startDate = garageQuotesPricingDetails && new Date(garageQuotesPricingDetails.jobStartDatetime);
    let endDate = garageQuotesPricingDetails && garageQuotesPricingDetails.jobEndDatetime && new Date(garageQuotesPricingDetails.jobEndDatetime);
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let addTime = (startDate && jobData && jobData.services && jobData.services.name !== "Servicing") ? (startDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) +' on ') :'';
    let endTime = (endDate && jobData && jobData.services &&jobData.services.name !== "Servicing") ?  (endDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) +' on ') :'';
    startDate = startDate &&
     // startDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) +
      //' on ' +
      addTime + ''+
      months[startDate.getMonth()] +
      ' ' +
      startDate.getDate() +
      ' ' +
      startDate.getFullYear();
    endDate = endDate &&
      //endDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) +
      //' on ' +
      endTime +''+
      months[endDate.getMonth()] +
      ' ' +
      endDate.getDate() +
      ' ' +
      endDate.getFullYear();
    let createdAt = garageQuotesPricingDetails && new Date(garageQuotesPricingDetails.createdAt);
    let createTime = (createdAt && createTime+ '' + jobData && jobData.services && jobData.services.name !== "Servicing") ? (createdAt.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) +' on ') :'';
    createdAt = createdAt && createTime+ '' + months[createdAt.getMonth()] + ' ' + createdAt.getDate() + ' ' + createdAt.getFullYear();
    let locationIndex = 0;
    console.log("garageQuotesPricingDetails = ", garageQuotesPricingDetails);
    if (garageQuotesPricingDetails && garageQuotesPricingDetails.garage && garageQuotesPricingDetails.garage.garagejobnotes && garageQuotesPricingDetails.garage.garagejobnotes.length) {
      jobNotesObj = garageQuotesPricingDetails.garage.garagejobnotes[0];
    }
    console.log("userbookingrequest_services = ", jobData);

    let quotesArr = [];
    let quotesNameArr = [];
    let userQuotesArr = [];
    let userQuotesNameArr = [];
    if (garageQuotesPricingDetails && jobData && garageQuotesPricingDetails.garagejobquotesdetail && jobData.userbookingrequest_services) {

      quotesArr = garageQuotesPricingDetails.garagejobquotesdetail;
      userQuotesArr = jobData.userbookingrequest_services;

      quotesArr.forEach((quoteItem) => {
        quotesNameArr.push(quoteItem.name);
      });
      userQuotesArr.forEach((userQuotesitem) => {
        userQuotesNameArr.push(userQuotesitem.name);
      });
      let wrapperArr = [];
      userQuotesArr.forEach((userQuotesitem) => {
        let obj = {};
        let index = userQuotesNameArr.indexOf(userQuotesitem.name);
        console.log("name = ", userQuotesNameArr[index]);
        if (!quotesNameArr.includes(userQuotesNameArr[index])) {
          obj = {
            name: userQuotesitem.name,
            parentId: userQuotesitem.parentId,
            serviceId: userQuotesitem.serviceId,
            parent: userQuotesitem.parent,
            amount: 0,
            currency: "",
            description: null
          };
          wrapperArr.push(obj);
        }
      });
      console.log("wrapperArr = ", wrapperArr);
      quotesArr = quotesArr.concat(wrapperArr);
    }

    console.log("quotesArr = ", quotesArr);
    const displayQuotesArr = quotesArr;
    const jobCardLocation = map(this.state.jobCardDetails, (val, key) => {
      let garage = val && val.garage;
      locationIndex += 1;
      let coverImg = "";
      if (garage && garage.images && garage.images.length) {
        coverImg = find(garage.images, function (image) {
          return image.isCover == true;
        });
      }
      return {
        lat: garage && Number(garage.latitude),
        lng: garage && Number(garage.longitude),
        pinImage: val.isActive
          ? this.state.activeSvg + locationIndex + this.state.svgEnd
          : this.state.svg + locationIndex + this.state.svgEnd,
        name: garage && garage.companyprofilename,
        rating: garage && garage.rating,
        distance: garage && garage.distance,
        review: garage && garage.reviews,
        zIndex: val.zIndex ? val.zIndex : 9,
        image: coverImg && coverImg.medium
      };
    });
    let serviceIndex = 0;
    {
      /*let DriverinfoDetails = (typeof jobData.garagejobquotes[0].emergencyjobdetails !== 'undefined') ? (jobData.garagejobquotes[0].emergencyjobdetails.length > 0 ? jobData.garagejobquotes[0].emergencyjobdetails[0].jobqueue : "0" ) :"0";*/
    }
    let DriverinfoDetails =
      jobData &&
        jobData.garagejobquotes &&
        jobData.garagejobquotes.length > 0 &&
        jobData.garagejobquotes[0].emergencyjobdetails[0] != undefined &&
        jobData.garagejobquotes[0].emergencyjobdetails.length > 0
        ? jobData.garagejobquotes[0].emergencyjobdetails[0].jobqueue
        : "0";
    //alert(DriverinfoDetails);



    return (
      <div>
        {
          this.state.showFullPageLoader ? <PageLoader /> : <div className="request-card">
            <div>
              {jobData && (
                <CarType
                  source={"requestview"}
                  authReducer={this.props.authReducer}
                  bookingRequestReducer={this.props.bookingRequestReducer}
                  actions={actions}
                  cardDetails={jobData}
                  vendorQuotesCount={jobData && jobData.totalJobQuotes}
                  jobLeftGridValue={jobLeftGridValue}
                  jobRightGridValue={jobRightGridValue}
                  userPaymentStatus={userPaymentStatus}
                  messageClick={jobId => {
                    this.viewMessaging(jobId);
                  }}
                  router={router}
                  quotesClick={this.jobDetail.bind(this, "quotes")}
                />
              )}
            </div>
            <div className="requestSection">
              <div className="row">
                {!this.state.isLoading
                  ? <div className={jobType == 'active' ? 'request-summary vendor-list-view' : 'request-summary'}>
                    <div className="row request-summary-header">
                      <div className="col-md-6 col-sm-12 col-xs-12 pad0">
                        <div className="row request-summary-tab">
                        {
                            jobData.plus!=true ?
                            <div className="col-md-6 col-sm-6 col-xs-6 pad0">
                            <div
                              className={this.state.jobUpdates == 'details' ? 'title active' : 'title'}
                              onClick={() => {
                                this.jobDetail('details');
                              }}
                            >
                              <span>Job Details</span>
                            </div>
                          </div>:null}
                          {(displayname == 'Active' ||
                            displayname == 'Completed' ||
                            displayname == 'Accepted' ||
                            displayname == 'In-progress' ||
                            displayname == 'Driver Accepted' ||
                            (previousDisplayname &&
                              displayname == 'Cancelled' &&
                              previousDisplayname != 'Waiting' &&
                              previousDisplayname != 'Cancelled' &&
                              previousDisplayname != 'Expired') ||
                            (previousDisplayname &&
                              displayname != 'Expired')) &&
                            displayname != 'Cancelled' &&
                            jobData.plus == true ?
                            " "
                            :
                            <div className="col-md-6 col-sm-6 col-xs-6 pad0">
                              <div
                                className={this.state.jobUpdates == 'quotes' ? 'title active' : 'title'}
                                onClick={() => {
                                  this.jobDetail('quotes');
                                }}
                              >
                                {/* <span>{this.jobData[0].statusIndicator=="accepted" || this.jobData[0].statusIndicator=="inProgress" ||this.jobData[0].statusIndicator=="completed" ?"Accepted Quotes":"Quotes"}</span> */}
                                <span>{this.statusIndicatorFunc(displayname, previousDisplayname)}</span>
                              </div>
                            </div>}
                        </div>
                      </div>
                    </div>
                    <div className="row request-summary-body">
                    {jobData.plus!=true ?
                    this.state.jobUpdates == 'details' &&
                      jobData &&
                      <div className="tab-jobDetails">
                        <JobDetails
                          displayname={displayname}
                          pollCountObj={this.state.pollCountObj}
                          batchId={this.state.batchId}
                          serviceTypes={jobData.services && jobData.services.name}
                          requestData={jobData}
                          router={router}
                          actions={actions}
                        />
                      </div>:
                      jobData &&
                      <div className="tab-jobDetails">
                        <JobDetails
                          displayname={displayname}
                          pollCountObj={this.state.pollCountObj}
                          batchId={this.state.batchId}
                          serviceTypes={jobData.services && jobData.services.name}
                          requestData={jobData}
                          router={router}
                          actions={actions}
                        />
                      </div> }

                      {jobData.plus &&


                        <span className="upload-section-wrappers">

                          { jobData.requeststatus.displayname == 'Completed' && jobData.paymentstatus.name != 'Paid' ?
                        jobData && jobData.paymentstatus &&  jobData.paymentstatus.name == 'Pending'  && this.state.isPayAtShopEnabled?
                          <div className="payment-container">

                            <h1>Payment Mode</h1>
                            <div className="col-md-12 repair-detail n-job-details">

                              <div className="col-md-4 col-sm-4 col-xs-4  pay-shop">

                                <img src={`${imageBasePath}/images/pay-at-shop.png`} alt="Pay at shop" />
                                <label htmlFor="bb" className="radio-custom-label title">Pay at Shop</label>
                                <label htmlFor="bb" className="radio-custom-label change"   onClick={ e => this.setState({ isPayAtShopEnabled: false }) } >Change</label>
                              </div>
                            </div>
                          </div>
                          :

                          (jobData.paymentstatus.name == 'Pending' || jobData.paymentstatus.name == 'Cancelled'  || jobData.paymentstatus.name == 'Declined'   || jobData.paymentstatus.name == 'Failed' && jobData.paymentstatus.method != 'Pay at Shop')?

                            <div className="payment-container">

                              <h1>Payment Mode</h1>
                              <div className=" repair-detail n-job-details">
                                                <div className="col-md-6 col-sm-6 col-xs-6 credit-card">

                                                  <img src={`${imageBasePath}/images/card-payment.png`} alt="Card payment" />
                                                  <input id="aa"  className="radio-custom"  onClick={ e => this.updateRadioButton("cardPayment") } checked={this.state.isCardPayment}   name="radio-group" type="radio"/>
                                                  <label htmlFor="aa" className="radio-custom-label title">Pay Online<span>Recommended</span></label>


                                                  <p className="description">Secure your payment by making payment through card</p>
                                                </div>

                                                <div className="col-md-6 col-sm-6 col-xs-6  pay-shop-padding">

                                                  <img src={`${imageBasePath}/images/pay-at-shop.png`} alt="Pay at shop" />
                                                  <input id="bb"  className="radio-custom"  onClick={ e => this.updateRadioButton("shopPayment") && this.setState({isPayAtShopEnabled: false}) }  checked={this.state.isShopPayment}   name="radio-group" type="radio"/>
                                                  <label htmlFor="bb" className="radio-custom-label title">Pay at Shop</label>
                                                </div>
                                              </div>



            {jobData.plus &&
           <div className="col-md-12 uploadeds">
        <div className="col-md-6 margin-correction">
        <div className="view"><label>View Pickup Information</label>
        <i  className={this.state.viewInfo ? "mdi mdi-chevron-up" : "mdi mdi-chevron-down"}  onClick={()=>this.hideandshow()}/>
        </div>
        {this.state.viewInfo ?
        <div>
        <div className="wrapper">
            <title className="title">{this.label.location} </title>
            {jobData.plus == true ?
            <span>
              {jobData && jobData.special_services[0].address
                ?jobData.special_services[0].address
                : "No location found"}
            </span>
            :
            <span>
              {jobData && requestData.location
                ? requestData.location
                : "No location found"}
            </span>
            }
          </div>

          <div className="wrapper">
            <title className="title">{this.label.dateTime} </title>
            <span>{StartDate}</span>
          </div>
          </div>:null}
        </div>

      </div>}
      <div className="row-md-12 plus-desktop">
               <div className="col-md-3"></div>
            <div className="col-md-3"></div>
               <div className="col-md-3">
               <a href={`tel:${phoneNumber}`} target="_blank"><button className="call" >Call Us</button></a>
               </div>
              <div className="col-md-3 paymentButton">
              <Button
                                                  isButtonLoading={this.state.isPaymentButtonLoading}
                                                  btnSize="sm"
                                                  fontSize={14}
                                                  btnType="red"
                                                  label="Make payment"
                                                  btnCallBack={() => {

                                                      this.makePayment( 'plus', jobData.id );

                                                  }}
                                                />
              {/* <button className="makepayment" onClick={() => {

          this.makePayment( 'plus', jobData.id );

            }}>Make payment</button> */}
              </div>
           </div>
           <div className="row-md-12 plus-mobile">
           <PlusSidebar  makePayment={()=>{this.makePayment('plus',jobData.id)}}   page="makePayment" router={this.props.router}  />

           </div>







                              </div>



                            : '' : '' }

                      {/* {displayname == 'Completed' && jobData.paymentstatus.name == 'Paid' ?
                        <div className="payment-container">

                        <h1>Payment Method</h1>
                        <div className="col-md-12 repair-detail n-job-details">

                        {jobData.paymentstatus.method == "Online (Telr)" ?
                          <div className="col-md-6 col-sm-6 col-xs-6 no-padding">

                            <img src={`${imageBasePath}/images/card-payment.png`}
                                 alt="Card payment"/>
                            <label htmlFor="aa" className="radio-custom-label title">Paid
                              Online</label>
                          </div>
                          :

                          <div className="col-md-6 col-sm-6 col-xs-12  no-padding">

                            <img src={`${imageBasePath}/images/pay-at-shop.png`}
                                 alt="Pay at shop"/>
                            <label htmlFor="bb" className="radio-custom-label title">Pay at
                              Shop</label>
                          </div>
                        }
                        </div>
                        </div>
                        : ''} */}
                        </span>




                      }

                      {this.state.jobUpdates == 'quotes'&& jobData.plus!=true &&
                        displayname != 'Waiting' && displayname != 'Expired' && displayname != 'Cancelled' &&
                        <div className="tab-quotes ">
                          <div className="col-md-6 clearfix left pad0">
                            <div
                              className={
                                this.state.currentWidth > 991
                                  ? 'quotes-view'
                                  : this.state.mobJD == 'job-card'  || displayname == 'Active' ? 'quotes-view' : 'quotes-view hide'
                              }
                            >
                              {(displayname == 'Active' ||
                                (displayname == 'Cancelled' && previousDisplayname == 'Active') ||
                                (displayname == 'Expired' && previousDisplayname == 'Active')) &&
                                <div className="title">
                                  <span className="qv-title">
                                    {vendorQuotesList.garagejobquotes && size(filter(vendorQuotesList.garagejobquotes, function (o) { return o.jobdetailstatusId != 5; }))}
                                    {' '}
                                    Quotes Received
                                  </span>
                                  <span className="mob-sort-filter">
                                    <i
                                      className="mdi mdi-filter-variant"
                                      onClick={() => this.setState({ mobileFilterItem: true })}
                                    />
                                    <i
                                      className="mdi mdi-swap-vertical"
                                      onClick={() => this.setState({ mobileSortItem: true })}
                                    />
                                  </span>
                                  <div className="filterSection active">
                                    <DropdownButton
                                      bsSize="small"
                                      id="dropdown-size-small"
                                      onToggle={() => { }}
                                      open={this.state.sortBydropdown}
                                      noCaret
                                      title={
                                        <div className="filterLabel showSortBy">
                                          <i className="mdi mdi-swap-vertical" />
                                          <label>Sort by</label>
                                          <i
                                            className={
                                              this.state.sortBydropdown
                                                ? 'mdi mdi-chevron-up downIcon downAlign pull-right'
                                                : 'mdi mdi-chevron-down downIcon downAlign pull-right'
                                            }
                                          />
                                        </div>
                                      }
                                    >
                                      <div className="sortFilter filterCard">
                                        <ul className="list-unstyled">
                                          <li
                                            onClick={() => {
                                              this.filterOption('dateNO', '-date');
                                              this.sortBy(jobId, '-date');
                                            }}
                                            className={this.state.filterSort == 'dateNO' ? 'active' : ''}
                                          >
                                            <label>
                                              Quote Date - Newest to Oldest
                                            </label>
                                            <span>
                                              <i
                                                className={
                                                  this.state.filterSort == 'dateNO' ? 'mdi mdi-check active' : 'hide'
                                                }
                                              />
                                            </span>
                                          </li>
                                          <li
                                            onClick={() => {
                                              this.filterOption('dateON', 'date');
                                              this.sortBy(jobId, 'date');
                                            }}
                                            className={this.state.filterSort == 'dateON' ? 'active' : ''}
                                          >
                                            <label>
                                              Quote Date - Oldest to Newest
                                            </label>
                                            <span>
                                              <i
                                                className={
                                                  this.state.filterSort == 'dateON' ? 'mdi mdi-check active' : 'hide'
                                                }
                                              />
                                            </span>
                                          </li>
                                          <li
                                            onClick={() => {
                                              this.filterOption('nameON', 'name');
                                              this.sortBy(jobId, 'name');
                                            }}
                                            className={this.state.filterSort == 'nameON' ? 'active' : ''}
                                          >
                                            <label>
                                              Name - Ascending - Descending
                                            </label>
                                            <span>
                                              <i
                                                className={
                                                  this.state.filterSort == 'nameON' ? 'mdi mdi-check active' : 'hide'
                                                }
                                              />
                                            </span>
                                          </li>
                                          <li
                                            onClick={() => {
                                              this.filterOption('nameNO', '-name');
                                              this.sortBy(jobId, '-name');
                                            }}
                                            className={this.state.filterSort == 'nameNO' ? 'active' : ''}
                                          >
                                            <label>
                                              Name - Descending - Ascending
                                            </label>
                                            <span>
                                              <i
                                                className={
                                                  this.state.filterSort == 'nameNO' ? 'mdi mdi-check active' : 'hide'
                                                }
                                              />
                                            </span>
                                          </li>
                                          <li
                                            onClick={() => {
                                              this.filterOption('DistNF', 'distance');
                                              this.sortBy(jobId, 'distance');
                                            }}
                                            className={this.state.filterSort == 'DistNF' ? 'active' : ''}
                                          >
                                            <label>
                                              Distance - Near to Far
                                            </label>
                                            <span>
                                              <i
                                                className={
                                                  this.state.filterSort == 'DistNF' ? 'mdi mdi-check active' : 'hide'
                                                }
                                              />
                                            </span>
                                          </li>
                                          <li
                                            onClick={() => {
                                              this.filterOption('DistFN', '-distance');
                                              this.sortBy(jobId, '-distance');
                                            }}
                                            className={this.state.filterSort == 'DistFN' ? 'active' : ''}
                                          >
                                            <label>
                                              Distance - Far to Near
                                            </label>
                                            <span>
                                              <i
                                                className={
                                                  this.state.filterSort == 'DistFN' ? 'mdi mdi-check active' : 'hide'
                                                }
                                              />
                                            </span>
                                          </li>
                                          <li
                                            onClick={() => {
                                              this.filterOption('ratingHL', '-rating');
                                              this.sortBy(jobId, '-rating');
                                            }}
                                            className={this.state.filterSort == 'ratingHL' ? 'active' : ''}
                                          >
                                            <label>
                                              Rating - Highest to Lowest
                                            </label>
                                            <span>
                                              <i
                                                className={
                                                  this.state.filterSort == 'ratingHL' ? 'mdi mdi-check active' : 'hide'
                                                }
                                              />
                                            </span>
                                          </li>
                                          <li
                                            onClick={() => {
                                              this.filterOption('ratingLH', 'rating');
                                              this.sortBy(jobId, 'rating');
                                            }}
                                            className={this.state.filterSort == 'ratingLH' ? 'active' : ''}
                                          >
                                            <label>
                                              Rating - Lowest to Highest
                                            </label>
                                            <span>
                                              <i
                                                className={
                                                  this.state.filterSort == 'ratingLH' ? 'mdi mdi-check active' : 'hide'
                                                }
                                              />
                                            </span>
                                          </li>
                                          <li
                                            onClick={() => {
                                              this.filterOption('priceHL', '-price');
                                              this.sortBy(jobId, '-price');
                                            }}
                                            className={this.state.filterSort == 'priceHL' ? 'active' : ''}
                                          >
                                            <label>
                                              Price - Highest to Lowest
                                            </label>
                                            <span>
                                              <i
                                                className={
                                                  this.state.filterSort == 'priceHL' ? 'mdi mdi-check active' : 'hide'
                                                }
                                              />
                                            </span>
                                          </li>
                                          <li
                                            onClick={() => {
                                              this.filterOption('priceLH', 'price');
                                              this.sortBy(jobId, 'price');
                                            }}
                                            className={this.state.filterSort == 'priceLH' ? 'active' : ''}
                                          >
                                            <label>
                                              Price - Lowest to Highest
                                            </label>
                                            <span>
                                              <i
                                                className={
                                                  this.state.filterSort == 'priceLH' ? 'mdi mdi-check active' : 'hide'
                                                }
                                              />
                                            </span>
                                          </li>
                                        </ul>
                                      </div>
                                    </DropdownButton>
                                  </div>
                                  <div
                                    className={this.state.filterActivated ? 'filterSection active' : 'filterSection'}
                                  >
                                    <DropdownButton
                                      bsSize="large"
                                      open={this.state.filterdropdown}
                                      onToggle={() => { }}
                                      noCaret
                                      id="dropdown-size-large"
                                      title={
                                        <div className="filterLabel showFilters ">
                                          <i className="mdi mdi-filter-variant" />
                                          <label>Filter</label>
                                          <i
                                            className={
                                              this.state.filterdropdown
                                                ? 'mdi mdi-chevron-up downIcon pull-right'
                                                : 'mdi mdi-chevron-down downIcon pull-right'
                                            }
                                          />
                                        </div>
                                      }
                                    >
                                      <li className="Filterby filterCard filter-dropdown">
                                        <div className="filter-left left">
                                          <div className="filterby-wrapper">
                                            <div className="f-card n-distance-range">
                                              <h5>Distance</h5>
                                              <InputRange
                                                formatLabel={distValue => `${distValue}km`}
                                                minValue={0}
                                                maxValue={100}
                                                value={this.state.distValue}
                                                onChange={distValue => this.setState({ distValue })}
                                              />
                                              <span className="range-min">{this.state.distValue.min + ' Km'}</span>
                                              <span className="range-max">{this.state.distValue.max + ' Km'}</span>
                                            </div>
                                            <div className="f-card n-distance-range">
                                              <h5>Price</h5>
                                              <InputRange
                                                formatLabel={priceValue => `${priceValue}AED`}
                                                minValue={0}
                                                maxValue={30000}
                                                value={this.state.priceValue}
                                                onChange={priceValue => this.setState({ priceValue })}
                                              />
                                              <span className="range-min">{this.state.priceValue.min + ' AED'}</span>
                                              <span className="range-max">{this.state.priceValue.max + ' AED'}</span>
                                            </div>
                                            <div className="f-card openAlign n-time-range">
                                              <h5>Open Between</h5>
                                              <ul className="list-unstyled">
                                                <li
                                                  className={this.state.daySelected['sunday'] ? 'active' : ''}
                                                  onClick={this.day.bind(this, 'sunday', 0)}
                                                >
                                                  SUN
                                                </li>
                                                <li
                                                  className={this.state.daySelected['monday'] ? 'active' : ''}
                                                  onClick={this.day.bind(this, 'monday', 1)}
                                                >
                                                  MON
                                                </li>
                                                <li
                                                  className={this.state.daySelected['tuesday'] ? 'active' : ''}
                                                  onClick={this.day.bind(this, 'tuesday', 2)}
                                                >
                                                  TUE
                                                </li>
                                                <li
                                                  className={this.state.daySelected['wednesday'] ? 'active' : ''}
                                                  onClick={this.day.bind(this, 'wednesday', 3)}
                                                >
                                                  wed
                                                </li>
                                                <li
                                                  className={this.state.daySelected['thrusday'] ? 'active' : ''}
                                                  onClick={this.day.bind(this, 'thrusday', 4)}
                                                >
                                                  thu
                                                </li>
                                                <li
                                                  className={this.state.daySelected['friday'] ? 'active' : ''}
                                                  onClick={this.day.bind(this, 'friday', 5)}
                                                >
                                                  fri
                                                </li>
                                                <li
                                                  className={this.state.daySelected['saturday'] ? 'active' : ''}
                                                  onClick={this.day.bind(this, 'saturday', 6)}
                                                >
                                                  sat
                                                </li>
                                              </ul>
                                              <div className="row date-time model-select date-time-align">
                                                <span className="n-time-from">
                                                  <TimePicker
                                                    showSecond={false}
                                                    className="custom-timepicker"
                                                    format={'h:mm a'}
                                                    value={this.state.rangeFromDefault}
                                                    onChange={this.rangefrom.bind(this)}
                                                    defaultValue={moment('2016-12-19T00:00:00+05:30')}
                                                    use12Hours
                                                  />
                                                  <i className="mdi mdi-chevron-down time-to" />
                                                </span>
                                                <span className="time-to-time n-time-to">to</span>
                                                <span className="n-time-to">
                                                  <TimePicker
                                                    showSecond={false}
                                                    className="custom-timepicker"
                                                    format={'h:mm a'}
                                                    onChange={this.rangeTo.bind(this)}
                                                    value={this.state.rangeToDefault}
                                                    defaultValue={moment('2016-12-19T23:59:00+05:30')}
                                                    use12Hours
                                                  />
                                                  <i className="mdi mdi-chevron-down time-to" />
                                                </span>
                                                {/* </div> */}
                                              </div>
                                            </div>
                                            <div className="f-card toggleBtn">
                                              <h5>Open 24/7</h5>
                                              <ToggleSwitch
                                                checked={this.toggleSwitchVal.Open24_7}
                                                size="small"
                                                onChange={this.switch.bind(this, 'Open24_7')}
                                                ref={node => {
                                                  this.toggleSwitch = node;
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        <div className="filter-right right toggleBtn">
                                          <div className="filterby-wrapper">
                                            <div className="f-card star-rating">
                                              <h5>Rating</h5>
                                              <Rating
                                                empty="mdi mdi-star-outline "
                                                full="mdi mdi-star active-star"
                                                initialRate={this.state.ratingValue}
                                                onChange={e => {
                                                  this.ratingOnChange(e);
                                                }}
                                              />
                                            </div>
                                            <div className="f-card ">
                                              <h5>Only show Favourites</h5>
                                              <ToggleSwitch
                                                checked={this.toggleSwitchVal.showFavourites}
                                                size="small"
                                                onChange={this.switch.bind(this, 'showFavourites')}
                                                ref={node => {
                                                  this.toggleSwitch = node;
                                                }}
                                              />
                                            </div>
                                            <div className="f-card payment-type">
                                              <h5>Payment by</h5>
                                              <div className="holder">
                                                <span className="pad0">Pay by Cash</span>
                                                <ToggleSwitch
                                                  checked={this.toggleSwitchVal.byCash}
                                                  size="small"
                                                  onChange={this.switch.bind(this, 'byCash')}
                                                  ref={node => {
                                                    this.toggleSwitch = node;
                                                  }}
                                                />
                                              </div>
                                              <div className="holder">
                                                <span className="">Pay by Credit Card</span>
                                                <ToggleSwitch
                                                  checked={this.toggleSwitchVal.byCreditcard}
                                                  size="small"
                                                  onChange={this.switch.bind(this, 'byCreditcard')}
                                                  ref={node => {
                                                    this.toggleSwitch = node;
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="filter-footer footer">
                                          <a
                                            onClick={() => {
                                              this.clearFilter(jobId);
                                            }}
                                          >
                                            Clear
                                          </a>
                                          <Button
                                            btnType="red"
                                            btnSize="sm"
                                            fontSize={15}
                                            label="Apply"
                                            btnCallBack={() => this.filterSelect(jobId)}
                                          />
                                        </div>
                                      </li>
                                    </DropdownButton>
                                  </div>
                                </div>}
                              <div className="quotes-left-body">
                                <div
                                  className={
                                    jobData &&
                                      jobData.requeststatus &&
                                      (displayname == 'Accepted' ||
                                        displayname == 'In-progress' ||
                                        displayname == 'Completed')
                                      ? 'requestQuotesScroll vendor-details-content'
                                      : (this.state.quotationView ? "requestQuotesScroll-view" : "requestQuotesScroll")
                                  }
                                >
                                  <CustomScroll
                                    heightRelativeToParent="calc(100%)"
                                    allowOuterScroll={true}
                                    scrollTo={this.state.scrollTo}
                                  >
                                    {(displayname == 'Active' ||
                                      (displayname == 'Cancelled' && previousDisplayname == 'Active') ||
                                      (displayname == 'Expired' && previousDisplayname == 'Active')) &&
                                      <div className="wrapper" ref={'quotesList'}>
                                        <div>
                                          {this.state.jobCardDetails &&
                                            map(this.state.jobCardDetails, (details, key) => {

                                              let coverImg = '';
                                              if (
                                                details &&
                                                details.garage &&
                                                details.garage.images &&
                                                details.garage.images.length
                                              ) {
                                                coverImg = find(details.garage.images, function (image) {
                                                  return image.isCover == true;
                                                });
                                              }
                                              if (details.jobdetailstatusId != 5) {

                                                return (
                                                  <QuotesCard
                                                    router={router}
                                                    isFavourite={details.garage && details.garage.isfavourite}
                                                    timings={details.garage && details.garage.garage_timings}
                                                    requestId={vendorQuotesList.id}
                                                    userRequestId={vendorQuotesList.requestid}
                                                    jobId={details.id}
                                                    vendorImage={coverImg && coverImg.small ? coverImg.small : ''}
                                                    key={key}
                                                    currency={details && details.currency?details.currency: "AED"}
                                                    finalAmount={
                                                      details && details.finalAmount
                                                        ? details.finalAmount : 0
                                                    }
                                                    totalamount={
                                                      details && details.totalamount
                                                        ? details.totalamount : 0
                                                    }
                                                    offerPrice={
                                                      details && details.discountAmount
                                                        ? details.discountAmount  : 0
                                                    }
                                                    discountAmount={details.discountAmount}
                                                    ref={quotesCard => {
                                                      details.isActive ? (this.currentTopEle = quotesCard) : '';
                                                    }}
                                                    activeClass={details.isActive ? 'active' : ''}
                                                    vendorName={details.garage && details.garage.companyprofilename}
                                                    vendorId={details.garage && details.garage.id}
                                                    rating={details.garage.rating}
                                                    distance={details.garage && details.garage.distance && round(details.garage.distance, 2)}
                                                    reviews={details.garage.reviews}
                                                    btnClickFunc={this.btnClickFunc.bind(this)}
                                                    viewMessaging={jobId => {
                                                      this.viewMessaging(jobId);
                                                    }}
                                                    removeFavourite={this.removeFav.bind()}
                                                    ClickedQuoteCard={vendorId => {
                                                      this.ClickedQuoteCard(
                                                        { key },
                                                        details.garage ? details.garage.id : undefined
                                                      );
                                                    }}
                                                  />
                                                );
                                              }
                                            })}
                                        </div>
                                      </div>}
                                    {displayname != 'Active' &&
                                      previousDisplayname != 'Active' &&
                                      garageQuotesPricingDetails &&
                                      garageQuotesPricingDetails.garage
                                      ? <div className={this.state.currentWidth < 900 ? '' : ''}>
                                        <AcceptedQuotes
                                          vendorDetailsVisible={() => this.setState({ mobJD: '' })}
                                          clientWidth={this.state.currentWidth}
                                          router={router}
                                          garageDetails={
                                            garageQuotesPricingDetails && garageQuotesPricingDetails.garage
                                          }
                                        />
                                      </div>
                                      : ''}
                                  </CustomScroll>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6 clearfix right pad0">
                            {(displayname == 'Active' ||
                              (displayname == 'Cancelled' && previousDisplayname == 'Active') ||
                              (displayname == 'Expired' && previousDisplayname == 'Active')) &&
                              <div className={this.state.mapView == true ? 'mapSection' : 'mapSection hide'}>
                                <div className="quotes-right-body">
                                  {
                                    console.log("setCenter = && mapsCenter= && jobCardLocation=", this.state.setCenter, this.state.mapsCenter, jobCardLocation)
                                  }
                                  <Gmaps
                                    mapDrag={() => {
                                      this.setState({ setCenter: false });
                                    }}
                                    infoPopUp={true}
                                    setCenter={this.state.setCenter}
                                    center={this.state.mapsCenter}
                                    markers={{ jobCardLocation }}
                                    markerClick={this.mapClick.bind(this)}
                                    zoom={16}
                                    containerElement={<div style={{ height: 100 + '%' }} />}
                                    mapElement={<div style={{ height: 100 + '%' }} />}
                                  />
                                  <span onClick={this.setCenter.bind(this)} className="current-position">
                                    <i className="mdi mdi-crosshairs-gps" />
                                  </span>
                                </div>
                              </div>}
                            {<div
                              id={this.state.mobJD == 'job-card' ? '' : 'quotesSection_fixed'}
                              className={
                                (this.state.quotationView == true && garageQuotesPricingDetails) ||
                                  (!this.state.mapView ||
                                    (displayname == 'Accepted' ||
                                      displayname == 'In-progress' ||
                                      displayname == 'Completed' || displayname == 'Driver Accepted' ||
                                      (displayname == 'Cancelled' && previousDisplayname == 'Accepted')))
                                  ? 'quotesSection'
                                  : 'quotesSection hide'
                              }
                            >
                              <span
                                className={this.state.currentWidth > 991 ? '' : this.state.mobJD == '' ? '' : 'hide'}
                              >
                                <div className="quotes-right-header">
                                  <div className="profile-head">
                                    <span>
                                      <img src={`${imageBasePath}/images/pic.png`} alt="" />
                                    </span>
                                    <label>
                                      {' '}
                                      {garageQuotesPricingDetails &&
                                        garageQuotesPricingDetails.garage &&
                                        garageQuotesPricingDetails.garage.companyprofilename}
                                      {' '}
                                    </label>
                                  </div>
                                  <i
                                    className={
                                      this.state.currentWidth < 900 ? 'mdi mdi-close mobile-quotes-close' : 'hide'
                                    }
                                    onClick={() => this.setState({ mobJD: 'job-card' ,isResponsiveViewClose : true})}
                                  />
                                  <div className={this.state.currentWidth < 991 ? 'hide' : 'quotes-right-tabs'}>
                                    <ul>
                                      <li
                                        className={this.state.quotation == true ? 'active' : ''}
                                        onClick={() => this.viewQuotation()}
                                      >
                                        Quote
                                      </li>
                                      {jobData &&
                                        jobData.serviceId != 4 &&
                                        <li
                                          className={this.state.messages == true ? 'active' : ''}
                                          onClick={() => this.viewMessages()}
                                        >
                                          Message
                                        </li>}
                                      {jobData &&
                                        jobData.serviceId == 4 &&
                                        (displayname == 'Accepted' || displayname == 'In-progress' || displayname == 'Driver Accepted') &&
                                        <li
                                          className={this.state.driverInfo == true ? 'active' : ''}
                                          onClick={() => this.driverDetails()}
                                        >
                                          Driver Details
                                        </li>}
                                    </ul>
                                    {displayname == 'Active' &&
                                      <a className="close-Tab" onClick={() => this.closeChat()}>
                                        <i className="mdi mdi-close" />
                                      </a>}
                                  </div>
                                </div>
                                {this.state.currentWidth < 991 &&
                                  this.state.jobUpdates == 'quotes' &&
                                  <div className={this.state.mobJD ? 'hide' : 'row'}>
                                    <div className="mobile-summary-tab">
                                      <div
                                        className={this.state.mobJD == '' ? 'col-sm-6 col-xs-6 pad0' : 'hide'}
                                        onClick={() => this.viewQuotation()}
                                      >
                                        <span
                                          className={
                                            this.state.quotation ? 'mobile-tab-title active' : 'mobile-tab-title'
                                          }
                                        >
                                          Quote
                                        </span>
                                      </div>
                                      <div
                                        className={this.state.mobJD == '' ? 'col-sm-6 col-xs-6 pad0' : 'hide'}
                                        onClick={() => this.viewMessages()}
                                      >
                                        <span
                                          className={
                                            !this.state.quotation ? 'mobile-tab-title active' : 'mobile-tab-title'
                                          }
                                        >
                                          Message
                                        </span>
                                      </div>
                                    </div>
                                  </div>}
                                <div className="quotes-right-body quotes-mob-body">
                                  <div className="requestQuotesScroll">
                                    {/*Quotation*/}
                                    <div
                                      className={
                                        this.state.quotation == true
                                          ? 'quotes-quotation-Section'
                                          : 'quotes-quotation-Section hide'
                                      }
                                    >
                                      <CustomScroll heightRelativeToParent="calc(100%)" allowOuterScroll={true}>
                                        <div className="quotation-head">
                                          <ul>
                                            <li>
                                              <label>Job Start Date:</label>
                                              <span>{startDate ? startDate : "-"}</span>
                                            </li>
                                            <li>
                                              <label>Job End Date:</label>
                                              <span>{endDate ? endDate : "-"}</span>
                                            </li>
                                            <li>
                                              <label>Quote Generated:</label>
                                              <span>{createdAt}</span>
                                            </li>
                                          </ul>
                                        </div>
                                        <div className="quotation-details">
                                          {

                                            garageQuotesPricingDetails &&
                                            garageQuotesPricingDetails.garagejobquotesdetail &&
                                            map(
                                              groupBy(displayQuotesArr, 'parentId'),
                                              (cardValue, jobCardKey) => {
                                                if (
                                                  cardValue &&
                                                  cardValue.length &&
                                                  cardValue[0] &&
                                                  cardValue[0].parentId > 4
                                                ) {


                                                  serviceIndex = serviceIndex + 1;
                                                  return (
                                                    <div className="quotation-block" key={jobCardKey}>
                                                      <div>
                                                        <h4>
                                                          {serviceIndex}
                                                          .
                                                          {' '}
                                                          {cardValue[0].parent && cardValue[0].parent.name}
                                                        </h4>
                                                        <ul>
                                                          {map(cardValue, (carAcc, accessoriesKey) => {
                                                             return (
                                                               <div>
                                                              <li key={accessoriesKey}>
                                                                <label>{carAcc.name}</label>
                                                                <span>{ !carAcc.currency ? "Unavailable" : carAcc.amount == 0 ? 0 : carAcc.amount ? Number(carAcc.amount).toFixed(2) : "--"} {carAcc.currency} {carAcc.description ?
                                                                  <span className="descp-tooltip">
                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Popover positionLeft={100} id={carAcc.name}> {carAcc.description}</Popover>}>
                                                                      <i className="mdi mdi-information-outline" />
                                                                    </OverlayTrigger>
                                                                  </span>
                                                                  :
                                                                  null
                                                                }
                                                                </span>
                                                              </li>

                                                              {carAcc.isinspectionrequired &&

                                                                  <div className="inspection-block">
                                                                    <div className="inspection-client">
                                                                       <label>Inspection Required</label>
                                                                       <span className="inspec-amount">
                                                                {(carAcc.inspectionamount=== 0|| carAcc.inspectionamount ===null) && <span className="free"> Free </span>} {carAcc.inspectionamount!==null ? Number(carAcc.inspectionamount).toFixed(2): 0.00}  AED
                                                                { carAcc.inspectiondescription &&
                                                                <span className="descp-tooltip">
                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Popover positionLeft={100} id="inscrDesc"> {carAcc.inspectiondescription}</Popover>}>
                                                                      <i className="mdi mdi-information-outline" />
                                                                    </OverlayTrigger>
                                                                  </span>
                                                                }
                                                                </span>
                                                              </div>
                                                            </div>
                                                              }
                                                              </div>
                                                            );
                                                          })}
                                                        </ul>
                                                      </div>
                                                    </div>
                                                  );
                                                } else if (cardValue[0]) {
                                                  return (
                                                    <div className="quotation-block" key={jobCardKey}>
                                                      <div>
                                                        {/* <h4>{jobCardKey}. {cardValue[0].name}</h4> */}
                                                        <ul>
                                                          {map(cardValue, (carAcc, accessoriesKey) => {
                                                            return (
                                                              <div>

                                                              <li className="without-h4" key={accessoriesKey}>
                                                                <label>{accessoriesKey + 1 + '. ' + carAcc.name}</label>
                                                                <span>{ !carAcc.currency ? "Unavailable" : carAcc.amount == 0 ? 0 : Number(carAcc.amount).toFixed(2) } {carAcc.currency} {carAcc.description ?
                                                                  <span className="descp-tooltip">
                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Popover positionLeft={100} id={carAcc.name}> {carAcc.description}</Popover>}>
                                                                      <i className="mdi mdi-information-outline" />
                                                                    </OverlayTrigger>
                                                                  </span>
                                                                  :
                                                                  null
                                                                }
                                                                </span>
                                                              </li>
                                                              {carAcc.isinspectionrequired &&


                                                                <div className="inspection-block">
                                                                  <div className="inspection-client">
                                                                     <label>Inspection Required</label>
                                                                     <span className="inspec-amount">
                                                              {(carAcc.inspectionamount=== 0|| carAcc.inspectionamount ===null) && <span className="free"> Free </span>} {carAcc.inspectionamount!==null ? Number(carAcc.inspectionamount).toFixed(2): 0.00}  AED
                                                              { carAcc.inspectiondescription &&
                                                              <span className="descp-tooltip">
                                                                  <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Popover positionLeft={100} id="inscrDesc"> {carAcc.inspectiondescription}</Popover>}>
                                                                    <i className="mdi mdi-information-outline" />
                                                                  </OverlayTrigger>
                                                                </span>
                                                              }
                                                              </span>
                                                            </div>
                                                          </div>
                                                            }
                                                              </div>

                                                            );
                                                          })}
                                                        </ul>
                                                      </div>
                                                    </div>
                                                  );
                                                }
                                              }
                                            )}

                                          {offerDiscount !==0 &&
                                            <div>
                                              <div className="promo-offer-block">
                                                <div>
                                                  Promo Code <span className="promo-offer-code">'{promoOffer.promoCode && promoOffer.promoCode}'</span>
                                                  <label> {offerDiscount === 0 ? "-" : ""} {offerDiscount!==0 ?offerDiscount:'-'}  {garageQuotesPricingDetails && garageQuotesPricingDetails.currency}</label>
                                                </div>
                                              </div>
                                              {promoOffer && promoOffer.discountPercentage &&
                                                <div className="promo-offer-block-percent">
                                                  <div>
                                                    <span className="promo-offer-code"> {promoOffer.discountPercentage}% off</span>
                                                  </div>
                                                </div>
                                              }
                                            </div>

                                          }
                                          <div className="quotation-total">
                                             {garageQuotesPricingDetails && garageQuotesPricingDetails.taxesAmount ?
                                               <div className="details">
                                                 <label>Sub Total</label>
                                                 <span>
                                                {offerDiscount ? garageQuotesPricingDetails && Number(garageQuotesPricingDetails.totalamount - offerDiscount).toFixed(2) : garageQuotesPricingDetails && Number(garageQuotesPricingDetails.totalamount).toFixed(2)}
                                                   {garageQuotesPricingDetails && ' ' +
                                                   garageQuotesPricingDetails.currency}
                                              </span>
                                               </div>
                                             : ""}
                                            {garageQuotesPricingDetails && garageQuotesPricingDetails.taxesAmount ?
                                            <div className="details">
                                              <label>VAT ({vatPercent}%)</label>
                                              <span>
                                                 {garageQuotesPricingDetails && Number(garageQuotesPricingDetails.taxesAmount).toFixed(2)}
                                                {garageQuotesPricingDetails && ' ' +
                                                garageQuotesPricingDetails.currency}
                                              </span>
                                            </div>
                                           : ""}

                                            {jobData.plus == true ?
                                             <div className="total">
                                             <label>Total</label>
                                             <span>
                                               {jobData && Number(jobData.finalAmount).toFixed(2)}
                                               {jobData && ' ' +
                                                 jobData.currency}
                                             </span>

                                           </div>
                                            :
                                             <div className="total">
                                             <label>Total</label>
                                             <span>
                                               {garageQuotesPricingDetails && Number(garageQuotesPricingDetails.finalAmount).toFixed(2)}
                                               {garageQuotesPricingDetails && ' ' +
                                                 garageQuotesPricingDetails.currency}
                                             </span>
                                           </div>
                                            }
                                            {/* <div className="total">
                                              <label>Total</label>
                                              <span>
                                                {garageQuotesPricingDetails && Number(garageQuotesPricingDetails.finalAmount).toFixed(2)}
                                                {garageQuotesPricingDetails && ' ' +
                                                  garageQuotesPricingDetails.currency}
                                              </span>
                                            </div> */}
                                            {garageQuotesPricingDetails && !garageQuotesPricingDetails.taxesAmount &&
                                            <div>

                                              <label className="vat-details">All prices include VAT.</label>

                                            </div>
                                            }
                                          </div>
                                          {jobNotesObj && jobNotesObj.jobnotes ? <div className="job-notes">
                                            <div className="job-notes-inner">
                                              <p><span><b>Note: </b></span><br /><span>{jobNotesObj.jobnotes}</span></p>
                                            </div>
                                          </div>
                                            : ''
                                          }


                                          {userPaymentStatus && displayname == 'Completed' && jobData.paymentstatus.name != 'Paid' ?
                                            jobData && jobData.paymentstatus &&  jobData.paymentstatus.name == 'Pending'  && this.state.isPayAtShopEnabled?
                                              <div className="payment-container">

                                                <h1>Payment Mode</h1>
                                                <div className="col-md-12 repair-detail n-job-details">

                                                  <div className="col-md-6 col-sm-6 col-xs-12  pay-shop">

                                                    <img src={`${imageBasePath}/images/pay-at-shop.png`} alt="Pay at shop" />
                                                    <label htmlFor="bb" className="radio-custom-label title">Pay at Shop</label>
                                                    <label htmlFor="bb" className="radio-custom-label change"   onClick={ e => this.setState({ isPayAtShopEnabled: false }) } >Change</label>
                                                  </div>
                                                </div>
                                              </div>
                                              :

                                            (jobData.paymentstatus.name == 'Pending' || jobData.paymentstatus.name == 'Cancelled'  || jobData.paymentstatus.name == 'Declined'   || jobData.paymentstatus.name == 'Failed' && jobData.paymentstatus.method != 'Pay at Shop')?

                                            <div className="payment-container">

                                              <h1>Payment Modees</h1>
                                              <div className="col-md-12 repair-detail n-job-details">
                                                <div className="col-md-6 col-sm-6 col-xs-6 credit-card">

                                                  <img src={`${imageBasePath}/images/card-payment.png`} alt="Card payment" />
                                                  <input id="aa"  className="radio-custom"  onClick={ e => this.updateRadioButton("cardPayment") } checked={this.state.isCardPayment}   name="radio-group" type="radio"/>
                                                  <label htmlFor="aa" className="radio-custom-label title">Pay Online<span>Recommended</span></label>


                                                  <p className="description">Secure your payment by making payment through card</p>
                                                </div>

                                                <div className="col-md-6 col-sm-6 col-xs-6  pay-shop-padding">

                                                  <img src={`${imageBasePath}/images/pay-at-shop.png`} alt="Pay at shop" />
                                                  <input id="bb"  className="radio-custom"  onClick={ e => this.updateRadioButton("shopPayment") }  checked={this.state.isShopPayment}   name="radio-group" type="radio"/>
                                                  <label htmlFor="bb" className="radio-custom-label title">Pay at Shop</label>
                                                </div>
                                              </div>

                                              <div className="quotation-accept-btn pull-right">

                                                <Button
                                                  isButtonLoading={this.state.isPaymentButtonLoading}
                                                  btnSize="sm"
                                                  fontSize={14}
                                                  btnType="red"
                                                  label="Continue"
                                                  btnCallBack={() => {

                                                      this.makePayment(
                                                        garageQuotesPricingDetails.id,
                                                        garageQuotesPricingDetails.userbookingrequestId);

                                                  }}
                                                />
                                              </div>
                                            </div>

                                            : '' : '' }

                                          {displayname == 'Completed' && jobData.paymentstatus.name == 'Paid' ?
                                            <div className="payment-container">

                                              <h1>Payment Method</h1>
                                              <div className="col-md-12 repair-detail n-job-details">

                                                {jobData.paymentstatus.method == "Online (Telr)" ?
                                                  <div className="col-md-6 col-sm-6 col-xs-6 no-padding">

                                                    <img src={`${imageBasePath}/images/card-payment.png`}
                                                         alt="Card payment"/>
                                                    <label htmlFor="aa" className="radio-custom-label title">Paid
                                                      Online</label>
                                                  </div>
                                                  :

                                                  <div className="col-md-6 col-sm-6 col-xs-12  no-padding">

                                                    <img src={`${imageBasePath}/images/pay-at-shop.png`}
                                                         alt="Pay at shop"/>
                                                    <label htmlFor="bb" className="radio-custom-label title">Pay at
                                                      Shop</label>
                                                  </div>
                                                }
                                              </div>
                                            </div>
                                          : ''}


                                          {displayname == 'Active'
                                            ?
                                            <div className="quotation-accept-btn pull-right">
                                              <Button
                                                isButtonLoading={this.state.isButtonLoading}
                                                btnSize="sm"
                                                fontSize={14}
                                                btnType="red"
                                                label="Accept Quote"
                                                btnCallBack={() => {
                                                  this.acceptQuotes(
                                                    vendorQuotesList.id,
                                                    garageQuotesPricingDetails.id,
                                                    vendorQuotesList.requestid,
                                                    router
                                                  );
                                                }}
                                              />
                                            </div>
                                            : ''}
                                          {displayname !== 'Completed' &&
                                          <div className="quotation-info pull-left"> This quote is based on the
                                            information submitted. Quotes may be subject to change upon further
                                            inspection of the vehicle.</div>
                                          }
                                        </div>

                                      </CustomScroll>
                                    </div>
                                    {/*ChatBox*/}
                                    {this.state.messages &&
                                      <div
                                        className={
                                          this.state.messages == true
                                            ? 'quotes-message-Section'
                                            : 'quotes-message-Section hide'
                                        }
                                      >
                                        <ChatBox
                                          {...this.props}
                                          jobData={jobData}
                                          selectedVendorId={
                                            garageQuotesPricingDetails && garageQuotesPricingDetails.garageId
                                              ? garageQuotesPricingDetails.garageId
                                              : this.state.selectedVendorId
                                          }
                                          selectedVendorName={
                                            garageQuotesPricingDetails &&
                                              garageQuotesPricingDetails.garage &&
                                              garageQuotesPricingDetails.garage.companyprofilename
                                              ? garageQuotesPricingDetails.garage.companyprofilename
                                              : ''
                                          }
                                        />
                                      </div>}
                                    {this.state.driverInfo &&
                                      <div className="google-wrapper">
                                        <div className="google-map">
                                          <GmapsEmergency
                                            center={{
                                              lat: Number(jobData.latitude),
                                              lng: Number(jobData.longitude)
                                            }}
                                            zoom={12}
                                            marker={{
                                              position: {
                                                lat: Number(jobData.latitude),
                                                lng: Number(jobData.longitude)
                                              }
                                            }}
                                            pinImage={`${imageBasePath}/images/drag-loc.png`}
                                            currentmarker={{
                                              position: {
                                                lat: Number(this.state.driverLatInfo),
                                                lng: Number(this.state.driverLngInfo)
                                              }
                                            }}
                                            currentImage={`${imageBasePath}/images/map_blue_pointer.png`}
                                            containerElement={<div style={{ height: 'auto', width: 100 + '%' }} />}
                                            mapElement={<div style={{ height: 500 + 'px', width: 100 + '%' }} />}
                                          />
                                        </div>
                                        {jobData.requeststatus.name == 'Accepted' &&
                                          <div className="google-map-overlay">
                                            {DriverinfoDetails !== '0' &&
                                              jobData &&
                                              <div className="driver-overly-text-center">
                                                <div>
                                                  {' '}
                                                  Driver has
                                                  {' '}
                                                  {jobData.garagejobquotes[0].emergencyjobdetails[0].jobqueue}
                                                  {' '}
                                                  jobs in Queue.
                                                </div>
                                                <div>
                                                  you will be able to track the vehicle once its starts navigating
                                                </div>
                                                <div> ETA : 30mins</div>
                                              </div>}
                                            {DriverinfoDetails === '0' &&
                                              <div className="driver-overly-text-center">
                                                <div>Please wait..the job is waiting for acceptance from driver</div>
                                              </div>}
                                          </div>}
                                        {DriverinfoDetails !== '0' &&
                                          jobData &&
                                          <div className="driver-emergency-display-container  business-adjust">
                                            <div className="col-xs-12 container-fluid demo">
                                              <div className="warning-message-length col-xs-12 display-emegency-container container-fluid">
                                                <div className="col-xs-2 emergency-type-data">
                                                  <img src={`${imageBasePath}/images/pic.png`} alt="driver_pic" />
                                                </div>
                                                <div className="col-xs-4 container-fluid">
                                                  <div className="emergency-type-data">
                                                    {jobData.garagejobquotes[0].emergencyjobdetails[0].driverName}
                                                  </div>
                                                  <div className="emergency-type-data driver-text-blue">
                                                    {jobData.garagejobquotes[0].emergencyjobdetails[0].driverPhone}
                                                  </div>
                                                </div>
                                                <div className="col-xs-6 emergency-type-data emergency-last-update">
                                                  Last Updated: <span>
                                                    {dateToTime(new Date(jobData.garagejobquotes[0].createdAt))}
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>}
                                      </div>}
                                  </div>
                                </div>
                              </span>
                            </div>}
                          </div>
                        </div>}
                    </div>
                  </div>
                  : <PageLoader />}
              </div>
            </div>
          </div>
        }
        {this.state.mobileSortItem && (
          <RequestMobileSort
            jobId={jobId}
            type="request"
            filterSort={this.state.filterSort}
            back={this.bckButton.bind(this)}
            filterOption={this.requestSort.bind(this)}
          />
        )}
        {this.state.mobileFilterItem && (
          <RequestMobileFilter
            jobId={jobId}
            type="request"
            stateVal={this.state}
            back={this.bckButton.bind(this)}
            filterOption={this.requestSort.bind(this)}
            day={this.day.bind(this)}
            rangefrom={this.rangefrom.bind(this)}
            rangeTo={this.rangeTo.bind(this)}
            toggleSwitchVal={this.toggleSwitchVal}
            switch={this.switch.bind(this)}
            ratingOnChange={this.ratingOnChange.bind(this)}
            clearFilter={this.clearFilter.bind(this)}
            filterSelect={this.filterSelect.bind(this)}
            distValueFunc={this.distValue.bind(this)}
          />
        )}
      </div>
    );
  }
}
